import { render, staticRenderFns } from "./filters.pug?vue&type=template&id=61014bd6&lang=pug&"
import script from "./filters.js?vue&type=script&lang=js&"
export * from "./filters.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61014bd6')) {
      api.createRecord('61014bd6', component.options)
    } else {
      api.reload('61014bd6', component.options)
    }
    module.hot.accept("./filters.pug?vue&type=template&id=61014bd6&lang=pug&", function () {
      api.rerender('61014bd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminLayout/components/filters/index.vue"
export default component.exports